import {useQuery} from '@tanstack/react-query';
import {usePackageDataTable} from '../probability/useItemData'; // 기존 패키지 정보 훅
import {internalApi} from '../../common/axios';
import {buildUrl} from '../../shared/utils/net';
import dayjs from 'dayjs';
import {useMemo} from "react";

const DEFAULT_BEFORE_DATE_VALUE = 6;

const fetchStatisticsData = async (date) => {
    const begin = dayjs(date).subtract(DEFAULT_BEFORE_DATE_VALUE, 'day').startOf('day').format('YYYY-MM-DD HH:mm:ss');
    const end = dayjs(date).endOf('day').format('YYYY-MM-DD HH:mm:ss');
    const {data} = await internalApi.get(buildUrl('manager/analysis/package', {begin, end}));
    return data.rows;
};

export const usePackageStatistics = (filters) => {
    const {date, platform, country, minLevel, maxLevel, firstPurchase} = filters;
    const {data: packageMasterData, isLoading: isMasterLoading, error: masterError} = usePackageDataTable();
    const {data: statisticsData, isLoading: isStatsLoading, error: statsError} = useQuery({
        queryKey: ['packageStatistics', date],
        queryFn: () => fetchStatisticsData(date),
        enabled: !!date,
    });

    const processedData = useMemo(() => {
        if (!statisticsData || !packageMasterData) {
            return [];
        }

        return statisticsData
            .filter(item =>
                item.lv >= minLevel &&
                item.lv <= maxLevel &&
                (platform === 'all' || item.market === platform) &&
                (country === 'ALL' || item.country === country) &&
                (firstPurchase === 'all' || item.isFirst === firstPurchase)
            )
            .map(item => (
                packageMasterData[item.productId] ? {
                    ...item,
                    packageName: packageMasterData[item.productId].packageName,
                    price: packageMasterData[item.productId].price,
                    category1: packageMasterData[item.productId].category1,
                    category2: packageMasterData[item.productId].category2,
                } : {
                    ...item,
                    packageName: '', price: 0, category1: '', category2: '',
                }
            ));
    }, [statisticsData, packageMasterData, platform, country, minLevel, maxLevel, firstPurchase]);
    return {
        data: processedData,
        isLoading: isMasterLoading || isStatsLoading,
        error: masterError || statsError,
    };
};